/* OPS-30 Lash Refills: style sets quick view (7 August 2026, Marcha)

   Some shelf products hold several lash styles under one product at one
   price. A single card cannot represent those honestly, and the shelf
   used to add whichever style came first without asking. Now the card
   opens a quick view, the same shape as the boxes on
   /pages/start-here#sh-kits, and she picks her styles in there. She can
   take several from the one set, which is the whole point when the box
   is any 4 for $69.

   THIS FILE NEVER TOUCHES THE BOX MATHS. Every style is a real but
   hidden .lrc-card rendered by sections/lash-refills-sets.liquid, so
   assets/lash-refills.js counts, prices, syncs and hydrates it exactly
   like any other lash. The quick view drives those cards by clicking
   their own buttons, which bubble to the shelf's delegated handler. If
   the deal maths ever changes, it changes in one file and this one
   follows for free.

   LOAD ORDER MATTERS. This script must run BEFORE lash-refills.js:
   prep() rewires the DOM (moves the hidden style cards into #lr-grid and
   repoints the set card onto a non-variant id) and lash-refills.js must
   build its registry from the finished DOM. sections/lash-refills-bundles.liquid
   loads them in that order. */

(function () {
  'use strict';
  if (window.__lrSetsInit) return;
  window.__lrSetsInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var grid = document.getElementById('lr-grid');
  var pool = $('[data-lr-set-cards]');
  if (!grid || !pool) return;

  var setData = {};
  $$('[data-lr-set-data]').forEach(function (el) {
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return; }
    if (d && d.handle) setData[d.handle] = d;
  });

  var strings = {};
  try { strings = JSON.parse(($('#lr-sets-strings') || {}).textContent || '{}') || {}; } catch (e) { strings = {}; }
  function str(key, fallback) { return strings[key] || fallback; }

  /* ---------- phase 1: prep, before lash-refills.js builds its registry ---------- */

  var setCards = {};

  (function prep() {
    /* The style cards move into the shelf so their button clicks reach
       the shelf's delegated handler. They stay display:none via
       assets/lash-refills-sets.css. */
    $$('.lrc-subcard', pool).forEach(function (el) { grid.appendChild(el); });

    Object.keys(setData).forEach(function (handle) {
      var card = null;
      $$('.lrc-card', grid).forEach(function (el) {
        if (!card && !el.classList.contains('lrc-subcard') && el.getAttribute('data-handle') === handle) card = el;
      });
      if (!card) return;
      setCards[handle] = card;

      /* Repoint the set card away from a real variant id. Its styles now
         carry the quantities, and two cards claiming one variant would
         double count in the moon and in the box price. */
      card.setAttribute('data-variant-id', 'set:' + handle);
      card.setAttribute('data-set', handle);

      var addBtn = $('[data-lr-add]', card);
      if (addBtn) {
        addBtn.removeAttribute('data-lr-add');
        addBtn.setAttribute('data-lrs-open', handle);
        addBtn.textContent = str('open', 'Choose your lashes');
      }
      /* The card's own stepper would paint a quantity this card no longer
         holds. The quick view is the only place to change a set. */
      var stepper = $('[data-lr-stepper]', card);
      if (stepper && stepper.parentNode) stepper.parentNode.removeChild(stepper);

      var media = $('[data-lr-media]', card);
      if (media) media.setAttribute('data-lrs-open', handle);

      /* The shelf's own See more popup ends in an Add to box that would
         try to add this card's id, which is no longer a real variant.
         The quick view replaces it and says more, so the link goes. */
      var seeMore = $('[data-lr-see-more]', card);
      if (seeMore && seeMore.parentNode) seeMore.parentNode.removeChild(seeMore);
    });
  })();

  /* ---------- phase 2: quick view, once the shelf has initialised ---------- */

  function ready(fn) {
    if (document.readyState === 'complete') setTimeout(fn, 0);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var modal = $('[data-lrs-modal]');
    var body = modal ? $('[data-lrs-body]', modal) : null;
    var panel = modal ? $('[data-lrs-panel]', modal) : null;
    var closeBtn = modal ? $('[data-lrs-close-btn]', modal) : null;
    var countEl = document.getElementById('lr-result-count');
    var picksBtn = document.getElementById('lr-picks-toggle');
    var opener = null;
    var openHandle = null;
    var rows = [];

    var shelfStrings = {};
    try { shelfStrings = JSON.parse((document.getElementById('lr-strings') || {}).textContent || '{}') || {}; } catch (e) { shelfStrings = {}; }

    function subCards(handle) {
      return $$('.lrc-subcard[data-subcard-of="' + handle + '"]', grid);
    }

    function qtyOf(sub) {
      var badge = $('[data-lr-qty-badge]', sub);
      var n = badge ? parseInt(badge.textContent, 10) : 0;
      return isNaN(n) ? 0 : n;
    }

    function setCount(handle) {
      return subCards(handle).reduce(function (a, el) { return a + qtyOf(el); }, 0);
    }

    function bump(sub, dir) {
      var btn = dir > 0
        ? ($('[data-lr-plus]', sub) || $('[data-lr-add]', sub))
        : $('[data-lr-minus]', sub);
      if (!btn) return;
      btn.click();
    }

    /* ---------- quick view ---------- */

    function buildGallery(data) {
      if (!data.images || !data.images.length) return null;
      var gal = document.createElement('div');
      gal.className = 'lrs-gal';
      var track = document.createElement('div');
      track.className = 'lrs-gal__track';
      data.images.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'lrs-gal__slide';
        var img = document.createElement('img');
        img.src = src;
        img.alt = i === 0 ? (data.name || '') : '';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.width = 700;
        img.height = 700;
        img.draggable = false;
        slide.appendChild(img);
        track.appendChild(slide);
      });
      gal.appendChild(track);

      if (data.images.length > 1) {
        var dots = document.createElement('div');
        dots.className = 'lrs-gal__dots';
        data.images.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lrs-gal__dot';
          dot.setAttribute('aria-label', 'Photo ' + (i + 1));
          dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          dot.addEventListener('click', function () {
            track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        });
        gal.appendChild(dots);
        var settle = null;
        track.addEventListener('scroll', function () {
          clearTimeout(settle);
          settle = setTimeout(function () {
            var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            $$('.lrs-gal__dot', dots).forEach(function (d, n) {
              d.setAttribute('aria-current', n === i ? 'true' : 'false');
            });
          }, 60);
        }, { passive: true });
      }
      return gal;
    }

    function refreshRows() {
      var total = 0;
      rows.forEach(function (row) {
        var n = qtyOf(row.sub);
        total += n;
        row.el.classList.toggle('is-picked', n > 0);
        if (row.add) row.add.hidden = n > 0;
        if (row.stepper) row.stepper.hidden = n === 0;
        if (row.count) row.count.textContent = n;
      });
      var tally = $('[data-lrs-tally]', body);
      if (tally) {
        tally.textContent = str('inBox', '[n] from this set in your box').replace('[n]', total);
        tally.hidden = total === 0;
      }
    }

    function build(handle) {
      var data = setData[handle];
      body.innerHTML = '';
      rows = [];

      var qv = document.createElement('div');
      qv.className = 'lrs-qv';

      var media = document.createElement('div');
      media.className = 'lrs-qv__media';
      var gal = buildGallery(data);
      if (gal) media.appendChild(gal);
      qv.appendChild(media);

      var info = document.createElement('div');
      info.className = 'lrs-qv__info';

      if (data.type) {
        var eyebrow = document.createElement('span');
        eyebrow.className = 'lrs-qv__eyebrow';
        eyebrow.textContent = data.type;
        info.appendChild(eyebrow);
      }

      var name = document.createElement('h3');
      name.className = 'lrs-qv__name';
      name.textContent = data.name || '';
      info.appendChild(name);

      if (data.raters) {
        var stars = document.createElement('div');
        stars.className = 'lrs-qv__reviews loox-rating';
        stars.setAttribute('data-rating', data.rating || '');
        stars.setAttribute('data-raters', data.raters || '');
        info.appendChild(stars);
      }

      var price = document.createElement('div');
      price.className = 'lrs-qv__price';
      price.textContent = (data.price || '') + ' ' + str('each', 'each');
      info.appendChild(price);

      if (data.blurb) {
        var desc = document.createElement('p');
        desc.className = 'lrs-qv__desc';
        desc.textContent = data.blurb;
        info.appendChild(desc);
      }

      var chooseLab = document.createElement('div');
      chooseLab.className = 'lrs-qv__label';
      chooseLab.textContent = str('chooseLabel', 'Choose your styles');
      info.appendChild(chooseLab);

      var list = document.createElement('ul');
      list.className = 'lrs-styles';

      (data.styles || []).forEach(function (style) {
        var sub = $('.lrc-subcard[data-variant-id="' + style.id + '"]', grid);
        if (!sub) return;

        var li = document.createElement('li');
        li.className = 'lrs-style';

        if (style.image) {
          var thumb = document.createElement('img');
          thumb.className = 'lrs-style__thumb';
          thumb.src = style.image;
          thumb.alt = '';
          thumb.loading = 'lazy';
          thumb.width = 64;
          thumb.height = 64;
          li.appendChild(thumb);
        }

        var label = document.createElement('span');
        label.className = 'lrs-style__name';
        label.textContent = style.title;
        li.appendChild(label);

        var row = { el: li, sub: sub, add: null, stepper: null, count: null };

        if (style.available === false) {
          var out = document.createElement('span');
          out.className = 'lrs-style__soldout';
          out.textContent = str('soldout', 'Back soon');
          li.appendChild(out);
        } else {
          var add = document.createElement('button');
          add.type = 'button';
          add.className = 'lrs-style__add';
          add.textContent = str('add', 'Add to box');
          add.addEventListener('click', function () { bump(sub, 1); refreshRows(); });
          li.appendChild(add);

          var stepper = document.createElement('div');
          stepper.className = 'lrs-style__stepper';
          stepper.hidden = true;

          var minus = document.createElement('button');
          minus.type = 'button';
          minus.className = 'lrs-style__step';
          minus.setAttribute('aria-label', 'Remove one ' + style.title + ' from your box');
          minus.textContent = '−';
          minus.addEventListener('click', function () { bump(sub, -1); refreshRows(); });

          var num = document.createElement('span');
          num.className = 'lrs-style__count';
          num.setAttribute('aria-live', 'polite');

          var plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'lrs-style__step';
          plus.setAttribute('aria-label', 'Add another ' + style.title + ' to your box');
          plus.textContent = '+';
          plus.addEventListener('click', function () { bump(sub, 1); refreshRows(); });

          stepper.appendChild(minus);
          stepper.appendChild(num);
          stepper.appendChild(plus);
          li.appendChild(stepper);

          row.add = add;
          row.stepper = stepper;
          row.count = num;
        }

        rows.push(row);
        list.appendChild(li);
      });

      info.appendChild(list);

      var tally = document.createElement('p');
      tally.className = 'lrs-qv__tally';
      tally.setAttribute('data-lrs-tally', '');
      tally.hidden = true;
      info.appendChild(tally);

      var done = document.createElement('button');
      done.type = 'button';
      done.className = 'lrs-qv__done';
      done.textContent = str('done', 'Done');
      done.addEventListener('click', close);
      info.appendChild(done);

      var pdp = document.createElement('a');
      pdp.className = 'lrs-qv__pdp';
      pdp.href = data.url || '#';
      pdp.textContent = str('pdp', 'View full details →');
      info.appendChild(pdp);

      qv.appendChild(info);
      body.appendChild(qv);
      body.scrollTop = 0;

      refreshRows();

      if (window.loox && typeof window.loox.reload === 'function') {
        try { window.loox.reload(); } catch (e) { /* Loox not ready */ }
      }
    }

    function open(handle) {
      if (!modal || !body || !setData[handle]) return;
      opener = document.activeElement;
      openHandle = handle;
      build(handle);
      if (panel) panel.setAttribute('aria-label', setData[handle].name || 'Choose your lash styles');
      modal.hidden = false;
      document.documentElement.classList.add('lrs-modal-open');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      body.innerHTML = '';
      rows = [];
      openHandle = null;
      document.documentElement.classList.remove('lrs-modal-open');
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    }

    if (modal) {
      $$('[data-lrs-close]', modal).forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') close();
      });
    }

    /* The shelf's own delegated handler owns #lr-grid clicks, so this one
       listens on the document and stops the open click there. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var trigger = e.target.closest('[data-lrs-open]');
      if (!trigger) return;
      if (e.target.closest('[data-lr-see-more]') || e.target.closest('.lrs-gal__dot')) return;
      e.preventDefault();
      e.stopPropagation();
      open(trigger.getAttribute('data-lrs-open'));
    }, true);

    /* ---------- keeping the shelf honest about the sets ---------- */

    var obs = null;

    function watch() {
      if (!obs) return;
      obs.observe(grid, { subtree: true, childList: true, attributes: true, characterData: true });
      if (countEl) obs.observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    function picksOn() {
      return !!(picksBtn && picksBtn.getAttribute('aria-pressed') === 'true');
    }

    /* Disconnected while it writes: sync's own edits would otherwise wake
       the observer, which would call sync, forever. */
    function sync() {
      if (obs) obs.disconnect();

      Object.keys(setCards).forEach(function (handle) {
        var card = setCards[handle];
        var n = setCount(handle);

        /* The card photo also carries data-lrs-open, so be specific: the
           label belongs to the button. */
        var btn = $('button[data-lrs-open]', card);
        if (btn) {
          var label = n > 0
            ? str('openPicked', '[n] in your box · Edit').replace('[n]', n)
            : str('open', 'Choose your lashes');
          if (btn.textContent !== label) btn.textContent = label;
        }
        var badge = $('[data-lr-qty-badge]', card);
        if (badge) {
          if (badge.textContent !== String(n)) badge.textContent = n;
          if (badge.hidden !== (n === 0)) badge.hidden = n === 0;
        }
        if (card.classList.contains('is-picked') !== (n > 0)) card.classList.toggle('is-picked', n > 0);

        /* In the picks view the shelf hides anything with no quantity of
           its own, which would hide a set whose styles she has picked. */
        if (picksOn() && card.classList.contains('is-hidden') !== (n === 0)) {
          card.classList.toggle('is-hidden', n === 0);
        }
      });

      if (countEl) {
        var all = $$('.lrc-card:not(.lrc-subcard)', grid);
        var shown = all.filter(function (el) { return !el.classList.contains('is-hidden'); });
        var want = picksOn()
          ? (shelfStrings.showingPicks || 'Showing the [n] in your box').replace('[n]', shown.length)
          : (shelfStrings.showing || 'Showing [n] of [total] lashes')
              .replace('[n]', shown.length)
              .replace('[total]', all.length);
        if (countEl.textContent !== want) countEl.textContent = want;
      }

      if (openHandle) refreshRows();

      watch();
    }

    /* setTimeout, not requestAnimationFrame: rAF does not fire in a
       background tab, so one queued frame would never land and every
       later change would be swallowed by the pending guard. */
    var pending = null;
    function queue() {
      if (pending) return;
      pending = setTimeout(function () { pending = null; sync(); }, 0);
    }

    if (window.MutationObserver) obs = new MutationObserver(queue);
    document.addEventListener('click', queue, true);

    sync();
  });
})();
